// extracted by mini-css-extract-plugin
export default {"host":"style_host__uuZb4","year":"style_year__slWLW"};